import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';
import { AuthService } from '../../services/auth/auth.service';
import { TokenRenewalService } from '../../services/token-renewal/token-renewal.service';

@Component({
  selector: 'bom-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
})
export class TimeoutComponent implements OnInit, OnDestroy {
  @ViewChild('buttonStayActive', { static: true })
  buttonStayActive: ElementRef;

  appConfig: AppConfig;
  tokenExpiresIn$: Observable<number>;
  tokenExpiresInString$: Observable<string>;
  show$: Observable<boolean>;

  private componentDestroyed$ = new Subject();

  constructor(
    private authService: AuthService,
    private tokenRenewalService: TokenRenewalService,
    private appConfigService: AppConfigService
  ) {}

  ngOnInit() {
    this.appConfig = this.appConfigService.getConfig();

    this.tokenExpiresIn$ = this.tokenRenewalService.tokenExpiresIn$;
    this.tokenExpiresInString$ = this.tokenRenewalService.tokenExpiresInString$;

    this.show$ = combineLatest([this.tokenExpiresIn$, this.authService.user$]).pipe(
      map(x => {
        const tokenExpiresIn = x[0];
        const user = x[1];

        if (!user) {
          return false;
        }

        return (
          tokenExpiresIn <= this.appConfig.accessTokenExpiringNotificationTime &&
          tokenExpiresIn >= 0
        );
      })
    );

    // Set focus on button when message is shown
    this.show$
      .pipe(
        takeUntil(this.componentDestroyed$),
        filter(show => show)
      )
      .subscribe(() => {
        setTimeout(() => {
          if (this.buttonStayActive) {
            this.buttonStayActive.nativeElement.focus();
          }
        }, 100);
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  stayActiveClicked() {
    this.tokenRenewalService.setActive();
  }
}
